// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BehanceSquareOutlinedSvg from "@fishx/icons-svg/es/asn/BehanceSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var BehanceSquareOutlined = function BehanceSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BehanceSquareOutlinedSvg
  }));
};

BehanceSquareOutlined.displayName = 'BehanceSquareOutlined';
export default React.forwardRef(BehanceSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BehanceSquareOutlined.js
// module id = 2072
// module chunks = 0